export const NuxtApollo = {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true, "sameSite": "lax"},
 clients: {"default": {"httpEndpoint": "https://www.orangetalent.nl/api/graphql", "httpLinkOptions": {"headers": {"x-api-key": "pjiBTihaj9JGUgCkFQiFNZcASHuP7yjT7TzaA3W5VQhHB0fxZRA1FEwt9PCrKY1C"}}, "authType": "Bearer", "authHeader": "Authorization", "tokenName": "apollo:default.token", "tokenStorage": "cookie", "defaultOptions": undefined}}
}